module.exports = __webpack_public_path__ + "static/media/GoingtoMountainTibet.35ca55ab.jpg";